import React from 'react'

export const debounceWaitTimeInMS = 2000

export const trendingPostDuration = {
  label: 'Month',
  duration: '30',
  unit: 'd'
}

export const approvedCodefilterOptions = [
  {
    label: 'Best',
    icon: '🏆'
  },
  {
    label: 'Trending',
    icon: '📈'
  },
  {
    label: 'New',
    icon: '☀️'
  },
]

export const reactions = [
  {
    label: 'hot',
    icon: '🔥'
  },
  {
    label: 'heart',
    icon: '💖'
  },
  {
    label: 'celebrate',
    icon: '🎉'
  },
]

export const statsViewOptions = [
    {
        view: 'compact',
        icon: (
            <svg width="25" height="25" viewBox="0 0 32 32" fill="inherit" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H8C8.53043 2 9.03914 2.21071 9.41421 2.58579C9.78929 2.96086 10 3.46957 10 4V8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10H4C3.46957 10 2.96086 9.78929 2.58579 9.41421C2.21071 9.03914 2 8.53043 2 8V4ZM12 4C12 3.46957 12.2107 2.96086 12.5858 2.58579C12.9609 2.21071 13.4696 2 14 2H18C18.5304 2 19.0391 2.21071 19.4142 2.58579C19.7893 2.96086 20 3.46957 20 4V8C20 8.53043 19.7893 9.03914 19.4142 9.41421C19.0391 9.78929 18.5304 10 18 10H14C13.4696 10 12.9609 9.78929 12.5858 9.41421C12.2107 9.03914 12 8.53043 12 8V4ZM22 4C22 3.46957 22.2107 2.96086 22.5858 2.58579C22.9609 2.21071 23.4696 2 24 2H28C28.5304 2 29.0391 2.21071 29.4142 2.58579C29.7893 2.96086 30 3.46957 30 4V8C30 8.53043 29.7893 9.03914 29.4142 9.41421C29.0391 9.78929 28.5304 10 28 10H24C23.4696 10 22.9609 9.78929 22.5858 9.41421C22.2107 9.03914 22 8.53043 22 8V4ZM2 14C2 13.4696 2.21071 12.9609 2.58579 12.5858C2.96086 12.2107 3.46957 12 4 12H8C8.53043 12 9.03914 12.2107 9.41421 12.5858C9.78929 12.9609 10 13.4696 10 14V18C10 18.5304 9.78929 19.0391 9.41421 19.4142C9.03914 19.7893 8.53043 20 8 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V14ZM12 14C12 13.4696 12.2107 12.9609 12.5858 12.5858C12.9609 12.2107 13.4696 12 14 12H18C18.5304 12 19.0391 12.2107 19.4142 12.5858C19.7893 12.9609 20 13.4696 20 14V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H14C13.4696 20 12.9609 19.7893 12.5858 19.4142C12.2107 19.0391 12 18.5304 12 18V14ZM22 14C22 13.4696 22.2107 12.9609 22.5858 12.5858C22.9609 12.2107 23.4696 12 24 12H28C28.5304 12 29.0391 12.2107 29.4142 12.5858C29.7893 12.9609 30 13.4696 30 14V18C30 18.5304 29.7893 19.0391 29.4142 19.4142C29.0391 19.7893 28.5304 20 28 20H24C23.4696 20 22.9609 19.7893 22.5858 19.4142C22.2107 19.0391 22 18.5304 22 18V14ZM2 24C2 23.4696 2.21071 22.9609 2.58579 22.5858C2.96086 22.2107 3.46957 22 4 22H8C8.53043 22 9.03914 22.2107 9.41421 22.5858C9.78929 22.9609 10 23.4696 10 24V28C10 28.5304 9.78929 29.0391 9.41421 29.4142C9.03914 29.7893 8.53043 30 8 30H4C3.46957 30 2.96086 29.7893 2.58579 29.4142C2.21071 29.0391 2 28.5304 2 28V24ZM12 24C12 23.4696 12.2107 22.9609 12.5858 22.5858C12.9609 22.2107 13.4696 22 14 22H18C18.5304 22 19.0391 22.2107 19.4142 22.5858C19.7893 22.9609 20 23.4696 20 24V28C20 28.5304 19.7893 29.0391 19.4142 29.4142C19.0391 29.7893 18.5304 30 18 30H14C13.4696 30 12.9609 29.7893 12.5858 29.4142C12.2107 29.0391 12 28.5304 12 28V24ZM22 24C22 23.4696 22.2107 22.9609 22.5858 22.5858C22.9609 22.2107 23.4696 22 24 22H28C28.5304 22 29.0391 22.2107 29.4142 22.5858C29.7893 22.9609 30 23.4696 30 24V28C30 28.5304 29.7893 29.0391 29.4142 29.4142C29.0391 29.7893 28.5304 30 28 30H24C23.4696 30 22.9609 29.7893 22.5858 29.4142C22.2107 29.0391 22 28.5304 22 28V24Z" fill="inherit"/>
            </svg>
        )
    },
    {
        view: 'detailed',
        icon: (
            <svg svg width="25" height="25" viewBox="0 0 38 38" fill="inherit" xmlns="http://www.w3.org/2000/svg" >
            <path d="M16.8232 22.2935V13.8725L35.3158 13.8725V22.2935H16.8232ZM35.3158 10.5041V5.45143C35.3158 3.5988 33.8 2.08301 31.9474 2.08301H16.7895V10.5041L35.3158 10.5041ZM5 5.45143L5 30.7146C5 32.5672 6.51579 34.083 8.36842 34.083H13.4211L13.4211 2.08301H8.36842C6.51579 2.08301 5 3.5988 5 5.45143ZM31.9474 34.083C33.8 34.083 35.3158 32.5672 35.3158 30.7146V25.662H16.7895V34.083H31.9474Z" fill="inherit"/>
            </svg>
        )
    }
]